// extracted by mini-css-extract-plugin
module.exports = {"article":"ArticleMini_article__Gcklz","title":"ArticleMini_title__qd4bi","textWrapper":"ArticleMini_textWrapper__Sh4iZ","image":"ArticleMini_image__luF5y"};